import script from "./BaseSpacer.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseSpacer.vue?vue&type=script&lang=ts&setup=true"

import "./BaseSpacer.vue?vue&type=style&index=0&id=f446c41e&lang=scss"

const __exports__ = script;

export default __exports__